import React from 'react'
import styles from './styles.css'
import Container from 'orionsoft-parts/lib/components/Container'
import FirstIcon from 'react-icons/lib/md/spellcheck'
import SecondIcon from 'react-icons/lib/md/assessment'
import ThirdIcon from 'react-icons/lib/md/call-made'

export default class Reasons extends React.Component {
  static propTypes = {}

  renderReason({icon: Icon, title, message}) {
    return (
      <div className="col-xs-12 col-sm-4">
        <div className={styles.icon}>
          <Icon size={40} color="#0069ff" />
        </div>
        <div className={styles.title}>{title}</div>
        <div className={styles.message}>{message}</div>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <Container>
          <div className="row">
            {this.renderReason({
              icon: FirstIcon,
              title: 'Simple',
              message:
                'No necesitas hacer integraciones complejas, en pocos pasos ya puedes empezar a vender'
            })}
            {this.renderReason({
              icon: SecondIcon,
              title: 'Barato',
              message: 'Cobramos una comisión de 0.6% a lo que recibes'
            })}
            {this.renderReason({
              icon: ThirdIcon,
              title: 'Seguro',
              message:
                'Nosotros te aseguramos que recibirás el monto que especificaste en pesos. No te preocupes de la volatilidad'
            })}
          </div>
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Home/Home/Reasons/index.js